import { useEffect, useState } from "react";
import LoadingScreen from "src/components/LoadingScreen";
import { VENDOR_API_URL } from "src/api/axios";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
// import RevenueChart from "./charts/RevenueChart";
// import RevenueBarChart from "./charts/RevenueBarChart";
import { Stack } from "@mui/material";

const Dashboard = (props) => {
  const axiosPrivate = useAxiosPrivate();
  const [loding, setLoding] = useState(true);
  const [orderCounts, setOrdersCount] = useState();
  const [allCount, setAllCount] = useState();

  async function getAllCount() {
    const response = await axiosPrivate.get(VENDOR_API_URL.vendorDashboard);
    setAllCount(response.data);
    setLoding(false);
  }

  async function getOrdersCount() {
    const response = await axiosPrivate.get(VENDOR_API_URL.getOrdersCount);
    setLoding(false);
    setOrdersCount(response.data);
  }
  useEffect(() => {
    setLoding(false);
    getOrdersCount();
    getAllCount();
  }, []);

  const formatCount = (count) => {
    // function done by shreya
    const COUNT_ABBRS = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
    const decimals = 2;

    const i = 0 === count ? count : Math.floor(Math.log(count) / Math.log(1000));
    let result = parseFloat((count / Math.pow(1000, i)).toFixed(decimals));
    result += `${COUNT_ABBRS[i]}`;
    
    let value = count;
    if (count >= 1000) {
      value = result;
    }
    return value;
  };

  return (
    <>
      {loding ? (
        <LoadingScreen />
      ) : (
        <>
          <h4 className="app_text_20_semibold">Dashboard</h4>
          <div className="container-fluid mt-4 px-0">
            {props?.userData?.category_type == 2 ||
              props?.userData?.category_type == 1 ? (
              <>
                <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-4 g-4">
                  <div className="col">
                    <div className="card text-center  dashboard_card">
                      <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                        Orders
                      </div>
                      <div className="card_content">
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.total_orders || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Total
                          </span>
                        </Stack>
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.todayOrders || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Today
                          </span>
                        </Stack>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="card text-center  dashboard_card">
                      <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                        Manage Order
                      </div>
                      <div className="card_content">
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.completed_orders || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Completed
                          </span>
                        </Stack>
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.pending_orders || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Pending
                          </span>
                        </Stack>
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.cancelled_orders}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Cancelled
                          </span>
                        </Stack>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="card text-center  dashboard_card">
                      <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                        Total Withdraw
                      </div>
                      <div className="card_content">
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            £{formatCount(allCount?.pending_payout.toFixed(2)) || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Pending
                          </span>
                        </Stack>
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            £{formatCount(allCount?.in_progress_payout.toFixed(2)) || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            In Progress
                          </span>
                        </Stack>
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            £{formatCount(allCount?.confrimed_payout.toFixed(2)) || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Confirmed
                          </span>
                        </Stack>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="card text-center  dashboard_card">
                      <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                        Placed Order
                      </div>
                      <div className="card_content">
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.pending_orders || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Order
                          </span>
                        </Stack>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="row g-5 mt-5">
                  <div className="col col-xl-6">
                    <RevenueChart />
                  </div>
                  <div className="col col-xl-6">
                    <RevenueBarChart />
                  </div>
                </div> */}
              </>
            ) : (
              ""
            )}
            {props?.userData?.category_type == 3 ? (
              <>
                <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-3 g-4">
                  <div className="col">
                    <div className="card text-center  dashboard_card">
                      <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                        Booked Tickets
                      </div>
                      <div className="card_content">
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.total_booked_tickets || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Total
                          </span>
                        </Stack>
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.today_booked_tickets || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Today
                          </span>
                        </Stack>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="card text-center  dashboard_card">
                      <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                        Manage Booking
                      </div>
                      <div className="card_content">
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.completed_booking || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Completed
                          </span>
                        </Stack>
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.pending_booking || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Pending
                          </span>
                        </Stack>
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.cancelled_booking || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Cancelled
                          </span>
                        </Stack>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="card text-center  dashboard_card">
                      <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                        Total Withdraw
                      </div>
                      <div className="card_content">
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            £{formatCount(allCount?.pending_payout?.toFixed(2)) || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Pending
                          </span>
                        </Stack>
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            £{formatCount(allCount?.in_progress_payout?.toFixed(2)) || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            In Progress
                          </span>
                        </Stack>
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            £{formatCount(allCount?.confrimed_payout?.toFixed(2)) || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Confirmed
                          </span>
                        </Stack>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="row g-5 mt-5">
                  <div className="col col-xl-6">
                    <RevenueChart />
                  </div>
                  <div className="col col-xl-6">
                    <RevenueBarChart />
                  </div>
                </div> */}
              </>
            ) : (
              ""
            )}
            {props?.userData?.category_type == 4 ? (
              <>
                <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-4 g-4">
                  <div className="col">
                    <div className="card text-center  dashboard_card">
                      <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                        Travels
                      </div>
                      <div className="card_content">
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.total_booked_tickets || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Total
                          </span>
                        </Stack>
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.today_booked_tickets || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Today
                          </span>
                        </Stack>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            {props?.userData?.category_type == 5 ? (
              <>
                <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-4 g-4">
                  <div className="col">
                    <div className="card text-center  dashboard_card">
                      <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                        Ngo
                      </div>
                      <div className="card_content">
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.total_charity_item || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Total
                          </span>
                        </Stack>
                        <Stack spacing={2}>
                          <span className="app_text_12_fw500 app_text_black_3">
                            {allCount?.today_charity_item || 0}
                          </span>
                          <span className="d-flex app_text_14_500 app_text_gray">
                            Today
                          </span>
                        </Stack>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Dashboard;
